export default "__VITE_ASSET__38574c69__"